// Auth API: setup, list operators, login, logout, me.
// Each function is a thin call. The queries/mutations live in useAuth.

import { api } from "../../lib/api";

export type Operator = { id: number; name: string };

export const authApi = {
  setupStatus: () => api<{ setupOpen: boolean }>("/api/auth/setup-status"),
  operators: () => api<Operator[]>("/api/auth/operators"),
  setup: (body: { name: string; pin: string }) =>
    api<Operator>("/api/auth/setup", { body }),
  login: (body: { operatorId: number; pin: string }) =>
    api<Operator>("/api/auth/login", { body }),
  logout: () => api<{ ok: true }>("/api/auth/logout", { method: "POST", body: {} }),
  me: () => api<Operator>("/api/auth/me"),
};
